<i [class]="'installer-category-icon fas fa-medal ' + categoryValue"></i>
